import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectTasksState } from "../store/tasks/selectors";
import { getCommentsByTaskId } from "../store/tasks/thunks";

export const useComments = (task, tenant_id) => {
  const dispatch = useDispatch();
  const { commentLoading: loading, columnsByTenants } =
    useSelector(selectTasksState);

  const { id: taskId, column_id: columnId } = task;

  const comments = useMemo(() => {
    const tasks = columnsByTenants?.[tenant_id]?.[columnId]?.tasks;

    const task = tasks?.find((t) => t.id === taskId);

    return task?.comments;
  }, [columnsByTenants, columnId, taskId, tenant_id]);

  useEffect(() => {
    if (taskId && columnId && comments === undefined) {
      dispatch(
        getCommentsByTaskId({
          task_id: taskId,
          column_id: columnId,
          tenant_id,
        }),
      );
    }
  }, [dispatch, taskId, comments, columnId]);

  return {
    loading,
    comments: comments || [],
  };
};
